import { useState } from "react";
import { Bell, User, LogOut } from "lucide-react";
import { Link, router } from "@inertiajs/react";
import { Toaster } from "sonner";
import { useSyncGuestDiagnostic } from "@/hooks/useSyncGuestDiagnostic";

interface SetupLayoutProps {
  children: React.ReactNode;
}

export function SetupLayout({ children }: SetupLayoutProps) {
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  useSyncGuestDiagnostic();

  const handleLogout = () => {
    setProfileMenuOpen(false);
    router.delete("/users/sign_out");
  };

  const handleProfileLinkClick = () => {
    setProfileMenuOpen(false);
  };

  return (
    <>
      {/* Header */}
      <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-border bg-background px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8 mt-[env(safe-area-inset-top)]">
        {/* Logo */}
        <div className="flex items-center">
          <h2 className="text-lg font-semibold bg-gradient-hero bg-clip-text text-transparent">
            Ukarte
          </h2>
        </div>

        {/* Right side */}
        <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
          <div className="flex items-center gap-x-4 lg:gap-x-6 ml-auto">
            <button
              type="button"
              className="-m-2.5 p-2.5 text-muted-foreground hover:text-foreground"
            >
              <span className="sr-only">View notifications</span>
              <Bell className="h-6 w-6" aria-hidden="true" />
            </button>

            <div
              className="hidden lg:block lg:h-6 lg:w-px lg:bg-border"
              aria-hidden="true"
            />

            {/* Profile */}
            <div className="relative flex items-center">
              <button
                type="button"
                onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                className="size-8 rounded-full bg-muted p-1 hover:bg-muted/80 transition-colors"
              >
                <User className="h-6 w-6" />
              </button>

              {profileMenuOpen && (
                <>
                  <div
                    className="fixed inset-0 z-40"
                    onClick={() => setProfileMenuOpen(false)}
                  />
                  <div className="absolute right-0 top-10 z-50 w-48 bg-background border border-border rounded-md shadow-lg">
                    <div className="py-1">
                      <button
                        onClick={handleLogout}
                        className="flex w-full items-center gap-x-3 px-4 py-2 text-sm text-muted-foreground hover:bg-muted/50 hover:text-foreground"
                      >
                        <LogOut className="size-4" />
                        ログアウト
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Page content */}
      <main className="flex-1 bg-background min-h-[calc(100vh-4rem)]">
        {children}
      </main>

      <Toaster position="top-right" richColors closeButton />
    </>
  );
}
